import React from 'react';
import { Cancel, CheckCircle, Rule } from '@mui/icons-material';
import { EBOL_STATUS } from '../../../../../../api/types/EbolStatus';

export const getIcon = (status: EBOL_STATUS) => {
  switch (status) {
    case EBOL_STATUS.ACCEPTED:
      return <CheckCircle color='success' />;
    case EBOL_STATUS.REJECTED:
      return <Cancel color='error' />;
    case EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES:
      return <Rule color='warning' />;
  }
};